import React from "react";
import { Info } from "lucide-react";

interface DisclaimerEstatisticoProps {
  text?: string;
  className?: string;
}

const DEFAULT_TEXT =
  "Resultados baseados em análises estatísticas, tendências históricas e simulações estratégicas. Conteúdo para fins de entretenimento — sem garantia de premiação.";

const DisclaimerEstatistico: React.FC<DisclaimerEstatisticoProps> = ({
  text = DEFAULT_TEXT,
  className = "",
}) => {
  return (
    <div
      className={`mt-6 flex items-start justify-center gap-2 px-4 py-3 text-xs text-muted-foreground/90 italic max-w-3xl mx-auto ${className}`}
      role="note"
    >
      <Info className="h-3.5 w-3.5 shrink-0 mt-0.5 opacity-70" />
      <span>{text}</span>
    </div>
  );
};

export default DisclaimerEstatistico;
